// singelton polling controller that manages the polling state
class PollingController {
    private static instance: PollingController;

    activeCaseId: string;
    stopCasePollingInfo: boolean = false;
    stopCollectionPollingInfo: boolean = false;

    private constructor() {}

    static getInstance(): PollingController {
        if (!PollingController.instance) {
            PollingController.instance = new PollingController();
        }
        return PollingController.instance;
    }

    updateActiveCase(caseId: string) {
        this.activeCaseId = caseId;
    }

    setStopCasePollingInfo(status: boolean) {
        this.stopCasePollingInfo = status;
    }

    setStopCollectionPollingInfo(status: boolean) {
        this.stopCollectionPollingInfo = status;
    }
}

export function getPollingCtrl() {
    return PollingController.getInstance();
}
